// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escpos-print-preview {
  color: #333;
  font-size: 12px;
  text-align: center;
  margin: 10px auto;
  word-wrap: break-word;
  background-color: #fff;
}
.escpos-print-preview pre {
  font-family: 'Roboto Mono', monospace;
  text-align: left;
  padding: 30px 9.5px 9.5px 9.5px;
  background-color: #fff;
}
@media screen and (max-width: 400px) {
  .escpos-print-preview pre {
    padding: 30px 0 5px 0;
  }
}
.escpos-print-preview strong {
  font-weight: 400;
}
.escpos-print-preview img {
  max-width: 100%;
  display: block;
  width: auto;
  margin: 0 auto;
}
.escpos-print-preview span.cpp10,
.escpos-print-preview span.cpp12,
.escpos-print-preview span.prop,
.escpos-print-preview span.dh,
.escpos-print-preview span.dw {
  display: inline;
  margin: 0;
  padding: 0;
}
.escpos-print-preview .qr-image {
  width: 40%;
}
.escpos-print-preview span.cpp10 {
  font-size: 12px;
}
.escpos-print-preview span.cpp12 {
  font-size: 12px;
}
.escpos-print-preview span.prop {
  font-size: 9pt;
}
.escpos-print-preview span.dh {
  /*font-size: 18px;*/
}
.escpos-print-preview span.dw {
  font-size: 17px;
  font-weight: 500;
}
.escpos-print-preview.escpos-print-preview-32-cols {
  width: 250px;
}
.escpos-print-preview.escpos-print-preview-32-cols pre {
  font-size: 11.25px;
}
.escpos-print-preview.escpos-print-preview-33-cols {
  width: 281px;
}
.escpos-print-preview.escpos-print-preview-33-cols pre {
  font-size: 11.25px;
}
.escpos-print-preview.escpos-print-preview-42-cols {
  width: 327px;
}
.escpos-print-preview.escpos-print-preview-42-cols pre {
  font-size: 12px;
}
@media screen and (max-width: 320px) {
  .escpos-print-preview.escpos-print-preview-42-cols {
    width: 310px;
  }
  .escpos-print-preview.escpos-print-preview-42-cols pre {
    font-size: 11.5px;
  }
}
.escpos-print-preview.escpos-print-preview-48-cols {
  width: 367px;
}
.escpos-print-preview.escpos-print-preview-48-cols pre {
  font-size: 11px;
}
@media screen and (max-width: 320px) {
  .escpos-print-preview.escpos-print-preview-48-cols {
    width: 310px;
  }
  .escpos-print-preview.escpos-print-preview-48-cols pre {
    font-size: 10px;
  }
}
.escpos-print-preview.escpos-print-preview-56-cols {
  width: 425px;
}
.escpos-print-preview.escpos-print-preview-56-cols pre {
  font-size: 9.25px;
}
@media screen and (max-width: 320px) {
  .escpos-print-preview.escpos-print-preview-56-cols {
    width: 310px;
  }
  .escpos-print-preview.escpos-print-preview-56-cols pre {
    font-size: 8.5px;
  }
}
.escpos-print-preview.escpos-print-preview-64-cols {
  width: 360px;
}
.escpos-print-preview.escpos-print-preview-64-cols span.cpp10 {
  font-size: 8.45px;
}
.escpos-print-preview.escpos-print-preview-64-cols span.cpp12 {
  font-size: 8.45px;
}
@media screen and (max-width: 320px) {
  .escpos-print-preview.escpos-print-preview-64-cols {
    width: 310px;
  }
  .escpos-print-preview.escpos-print-preview-64-cols span.cpp10 {
    font-size: 7.5px;
  }
  .escpos-print-preview.escpos-print-preview-64-cols span.cpp12 {
    font-size: 7.5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/escpos-print-preview.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,cAAc;AAChB;AACA;;;;;EAKE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".escpos-print-preview {\n  color: #333;\n  font-size: 12px;\n  text-align: center;\n  margin: 10px auto;\n  word-wrap: break-word;\n  background-color: #fff;\n}\n.escpos-print-preview pre {\n  font-family: 'Roboto Mono', monospace;\n  text-align: left;\n  padding: 30px 9.5px 9.5px 9.5px;\n  background-color: #fff;\n}\n@media screen and (max-width: 400px) {\n  .escpos-print-preview pre {\n    padding: 30px 0 5px 0;\n  }\n}\n.escpos-print-preview strong {\n  font-weight: 400;\n}\n.escpos-print-preview img {\n  max-width: 100%;\n  display: block;\n  width: auto;\n  margin: 0 auto;\n}\n.escpos-print-preview span.cpp10,\n.escpos-print-preview span.cpp12,\n.escpos-print-preview span.prop,\n.escpos-print-preview span.dh,\n.escpos-print-preview span.dw {\n  display: inline;\n  margin: 0;\n  padding: 0;\n}\n.escpos-print-preview .qr-image {\n  width: 40%;\n}\n.escpos-print-preview span.cpp10 {\n  font-size: 12px;\n}\n.escpos-print-preview span.cpp12 {\n  font-size: 12px;\n}\n.escpos-print-preview span.prop {\n  font-size: 9pt;\n}\n.escpos-print-preview span.dh {\n  /*font-size: 18px;*/\n}\n.escpos-print-preview span.dw {\n  font-size: 17px;\n  font-weight: 500;\n}\n.escpos-print-preview.escpos-print-preview-32-cols {\n  width: 250px;\n}\n.escpos-print-preview.escpos-print-preview-32-cols pre {\n  font-size: 11.25px;\n}\n.escpos-print-preview.escpos-print-preview-33-cols {\n  width: 281px;\n}\n.escpos-print-preview.escpos-print-preview-33-cols pre {\n  font-size: 11.25px;\n}\n.escpos-print-preview.escpos-print-preview-42-cols {\n  width: 327px;\n}\n.escpos-print-preview.escpos-print-preview-42-cols pre {\n  font-size: 12px;\n}\n@media screen and (max-width: 320px) {\n  .escpos-print-preview.escpos-print-preview-42-cols {\n    width: 310px;\n  }\n  .escpos-print-preview.escpos-print-preview-42-cols pre {\n    font-size: 11.5px;\n  }\n}\n.escpos-print-preview.escpos-print-preview-48-cols {\n  width: 367px;\n}\n.escpos-print-preview.escpos-print-preview-48-cols pre {\n  font-size: 11px;\n}\n@media screen and (max-width: 320px) {\n  .escpos-print-preview.escpos-print-preview-48-cols {\n    width: 310px;\n  }\n  .escpos-print-preview.escpos-print-preview-48-cols pre {\n    font-size: 10px;\n  }\n}\n.escpos-print-preview.escpos-print-preview-56-cols {\n  width: 425px;\n}\n.escpos-print-preview.escpos-print-preview-56-cols pre {\n  font-size: 9.25px;\n}\n@media screen and (max-width: 320px) {\n  .escpos-print-preview.escpos-print-preview-56-cols {\n    width: 310px;\n  }\n  .escpos-print-preview.escpos-print-preview-56-cols pre {\n    font-size: 8.5px;\n  }\n}\n.escpos-print-preview.escpos-print-preview-64-cols {\n  width: 360px;\n}\n.escpos-print-preview.escpos-print-preview-64-cols span.cpp10 {\n  font-size: 8.45px;\n}\n.escpos-print-preview.escpos-print-preview-64-cols span.cpp12 {\n  font-size: 8.45px;\n}\n@media screen and (max-width: 320px) {\n  .escpos-print-preview.escpos-print-preview-64-cols {\n    width: 310px;\n  }\n  .escpos-print-preview.escpos-print-preview-64-cols span.cpp10 {\n    font-size: 7.5px;\n  }\n  .escpos-print-preview.escpos-print-preview-64-cols span.cpp12 {\n    font-size: 7.5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
